import Icon from '../ui/Icon';

// One section of the application form.
//
// The form is long — nine blocks before the documents — and every heading
// used to be the same weight of grey text, so it read as one unbroken wall.
// A numbered icon, a rule, and a card per section give the eye somewhere to
// rest and make the length feel navigable rather than endless.
export default function FormSection({
  index, icon, title, description, children, className = '', ...rest
}) {
  return (
    <section
      className={`rounded-2xl border border-gray-100 bg-white p-5 shadow-sm md:p-6 ${className}`}
      {...rest}
    >
      <header className="mb-5 flex items-start gap-3.5">
        <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
          <Icon name={icon} className="h-5 w-5" />
          {index != null && (
            <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-primary-600 text-[10px] font-bold text-white">
              {index}
            </span>
          )}
        </span>
        <div className="min-w-0 pt-0.5">
          <h3 className="font-serif text-lg font-bold leading-snug text-gray-900 md:text-xl">
            {title}
          </h3>
          {description && (
            <p className="mt-1 text-sm leading-relaxed text-gray-500">{description}</p>
          )}
        </div>
      </header>
      {children}
    </section>
  );
}
